import { Bookable, Grade, Teacher, Time } from 'src/store/models/timetable/index.js'

import { User } from 'src/store/models/index.js'

const defaultTimeframe = {
  week_minutes_begins_at: 480,
  week_minutes_ends_at: 960,
  lesson_minutes_begins_at: 480,
  lesson_minutes_ends_at: 960
}

export const getZeroSafeId = (id) => String(Number(id)) === String(id) ? Number(id) : id

const timetablePageOrganiser = {
  data: () => ({
    entities: {
      teachers: Teacher,
      grades: Grade,
      bookables: Bookable,
      users: User
    },
    timeFrame: defaultTimeframe,
    defaultTimeframe,
    selectedEntity: {
      entity: null,
      id: null
    }
  }),
  computed: {
    labels () {
      return Time.query()
        .where('is_hidden', false)
        .orderBy('begins_at').get()
        .map(label => ({
          ...label,
          begins_at: label.begins_atMoment,
          ends_at: label.ends_atMoment,
          minutes_begins_at: this.getMinutes(label.begins_atMoment),
          minutes_ends_at: this.getMinutes(label.ends_atMoment),
          time_begins_at: label.begins_atMoment.unix(),
          time_ends_at: label.ends_atMoment.unix()
        }))
    },
    selectedEntityObject () {
      if (!this.selectedEntity.entity) return null
      if (!this.entities[this.selectedEntity.entity]) return null
      return this.entities[this.selectedEntity.entity].query()
        .whereIdIn([this.selectedEntity.id, Number(this.selectedEntity.id), String(this.selectedEntity.id)])
        .with('grade')
        .first()
    },
    isTeacher () {
      if (!this.selectedEntity.entity || !this.selectedEntityObject) return false
      if (this.selectedEntity.entity === 'teachers') return true

      return this.selectedEntity.entity === 'users' &&
        this.selectedEntityObject.type === 'TEACHER'
    },
    dayBeginsAt () {
      return this.timeFrame.week_minutes_begins_at
    }
  },
  methods: {
    getMinutes (m) {
      return m.get('minute') + m.get('hour') * 60
    }
  },
  watch: {
    selectedEntity: {
      handler: async function (newValue, oldValue) {
        if (oldValue && newValue.entity === oldValue.entity && newValue.id === oldValue.id) return
        if (this.$route.name !== 'management-timetable') return this.fetchTimetableByEntity(null, true)

        // For the management timetable, reload lessons/courses filtered to the new entity.
        // Only proceed when the timetable project is already initialised (headers.school is set).
        // When headers.school is null the school watcher's init flow will handle the first load.
        // We intentionally do NOT require this.school (local fetchSchool result) because when
        // navigating from basedata the project is already initialised but fetchSchool hasn't
        // resolved yet — waiting for it would cause lessons to never be fetched.
        if (this.$store.state.timetablePlanner.headers.school) {
          // Skip if the planner mode hasn't been set for this page yet. When navigating from a
          // non-management page, timetableFromPlanner is still false (cleared by
          // AdministrationWrapper unmount) while headers.school persists from the previous
          // session. The school watcher will handle the full initialisation including heavy
          // entities, so firing here would produce a duplicate request.
          const isManagementRoute = !!(this.$route.meta.switchManagementData)
          if (this.$store.state.timetablePlanner.timetableFromPlanner !== isManagementRoute) return

          this.$store.dispatch('timetablePlanner/loadManagementTimetableEntities', {
            entity: newValue.entity,
            entity_id: getZeroSafeId(newValue.id),
            reload: true
          })
        }
      },
      immediate: false
    },
    '$route.params': {
      handler (newValue, oldValue) {
        if (oldValue && newValue.id === oldValue.id && newValue.type === oldValue.type) return
        const id = newValue.id
        this.selectedEntity = {
          entity: newValue.entity,
          id: getZeroSafeId(id)
        }
      },
      immediate: true
    }
  }
}

export default timetablePageOrganiser
